import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';

const useQuestions = ({ questionIds, extraFields } = {}) => {
  const query = gql`
    query UseQuestions($questionIds: [ID!]!) {
      questions(ids: $questionIds) {
        id
        title
        ${extraFields || ''}
      }
    }
  `;

  const { data: { questions } = {}, ...rest } = useQuery(query, {
    variables: { questionIds },
    skip: !questionIds?.length,
  });

  return {
    questions,
    ...rest,
  };
};

export default useQuestions;
